import { render, staticRenderFns } from "./OtherPriceManage.vue?vue&type=template&id=2e2e0cff&"
import script from "./OtherPriceManage.vue?vue&type=script&lang=js&"
export * from "./OtherPriceManage.vue?vue&type=script&lang=js&"
import style0 from "./OtherPriceManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports